import { useFormContext } from 'react-hook-form'

import { FormError, SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface ReferenceInstrumentTypeIdFormFieldProps {
  instrumentTypes?: { label: string; value: number }[]
  loading?: boolean
}

export const ReferenceInstrumentTypeIdFormField: React.FC<
  ReferenceInstrumentTypeIdFormFieldProps
> = ({ instrumentTypes, loading }) => {
  const { control, setValue } = useFormContext<{ reference_instrument_type_id: number }>()

  return (
    <FormField
      name="reference_instrument_type_id"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Reference Instrument Type</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              loading={loading}
              value={field.value?.toString()}
              options={instrumentTypes?.map(({ label, value }) => ({
                label,
                value: value?.toString(),
              }))}
              placeholder={'Select a Product Type'}
              setValue={(val) =>
                setValue('reference_instrument_type_id', parseInt(val), { shouldValidate: true })
              }
            />
          </FormItem>
        )
      }}
    />
  )
}
